import React from "react";
import a from "./1.png";
import b from "./2.png";
import c from "./3.png";
import d from "./4.png";
import e from "./5.png";
import f from "./6.png";
import g from "./0.png";
import { Toast } from "react-bootstrap";

function GetUserHand(props) {
  const num = props.usernum2;
  if (num === "1")
    return <img src={a} className="img-fluid img75" alt="Responsive" />;
  else if (num === "2")
    return <img src={b} className="img-fluid img75" alt="Responsive" />;
  else if (num === "3")
    return <img src={c} className="img-fluid img75" alt="Responsive" />;
  else if (num === "4")
    return <img src={d} className="img-fluid img75" alt="Responsive" />;
  else if (num === "5")
    return <img src={e} className="img-fluid img75" alt="Responsive" />;
  else if (num === "6")
    return <img src={f} className="img-fluid img75" alt="Responsive" />;
  else return <img src={g} className="img-fluid img75" alt="Responsive" />;
}

function GetBatter(props) {
  const batter = props.batter;
  if (batter === 0)
    return <span className="badge badge-secondary">Batting</span>;
  else return <span></span>;
}

class HandCricket extends React.Component {
  constructor(props) {
    super(props);
    // turn 0 = user turn, turn 1 = computer turn
    this.state = {
      usernum: "",
      usernum2: "",
      compnum2: "",
      usertotal: 0,
      computertotal: 0,
      turn: 0,
      winner: "",
      userhand: 0,
      computerHand: 0
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  resetDefaults() {
    this.setState({ usernum: "" });
    this.setState({ usernum2: "" });
    this.setState({ compnum2: "" });
    this.setState({ usertotal: 0 });
    this.setState({ computertotal: 0 });
    this.setState({ turn: 0 });
    this.setState({ winner: "" });
    this.setState({ userhand: 0 });
    this.setState({ computerHand: 0 });
  }

  handleChange(event) {
    event.preventDefault();
    this.setState({ usernum: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    const userscore = this.state.usernum;
    const computerscore = String(Math.floor(Math.random() * 6) + 1);

    if (userscore === "") return;
    if (parseInt(userscore) > 6 || parseInt(userscore) < 1) return;
    // if(this.state.turn === 2)
    // console.log(computerscore);
    this.setState({ userhand: userscore });
    this.setState({ computerHand: computerscore });
    if (
      parseInt(userscore) === parseInt(computerscore) &&
      this.state.turn === 0
    )
      this.setState({ turn: 1 });
    else if (
      parseInt(userscore) === parseInt(computerscore) &&
      this.state.turn === 1
    ) {
      this.setState({ winner: "user" });
      setTimeout(() => {
        this.resetDefaults();
      }, 5000);
      return;
    } else {
      if (this.state.turn === 0) {
        this.setState({ usernum2: userscore });
        this.setState(
          (prevState, props) => ({
            usertotal: prevState.usertotal + parseInt(userscore)
          }),
          () => {
            // console.log(this.state.usertotal)
            if (
              this.state.turn === 1 &&
              this.state.computertotal > this.state.usertotal
            ) {
              this.setState({ winner: "computer" });
              this.setState({ usernum2: "GameOver" });
              this.setState({ compnum2: "GameOver" });
              setTimeout(() => {
                this.resetDefaults();
              }, 5000);
              return;
            }
          }
        );
      } else {
        this.setState({ compnum2: computerscore });
        this.setState(
          (prevState, props) => ({
            computertotal: prevState.computertotal + parseInt(computerscore)
          }),
          () => {
            // console.log(this.state.computertotal)
            if (
              this.state.turn === 1 &&
              this.state.computertotal > this.state.usertotal
            ) {
              this.setState({ winner: "computer" });
              this.setState({ usernum2: "GameOver" });
              this.setState({ compnum2: "GameOver" });
              setTimeout(() => {
                this.resetDefaults();
              }, 5000);
              return;
            }
          }
        );
      }
    }

    // to clear the input after submission, so that the user can enter new number again
    this.setState({ usernum: "" });
  }

  render() {
    return (
      <div>
        {/* #aa4244 */}
        <h3 className="display-4 d-flex justify-content-center h1color">
          Hand cricket
        </h3>
        <div className="container constainercust">
          <div className="row">
            <div className="col imgpad d-flex justify-content-center">
              <GetUserHand usernum2={this.state.userhand} />
            </div>

            <div className="col imgpad d-flex justify-content-center">
              <GetUserHand usernum2={this.state.computerHand} />
            </div>
          </div>
          <div className="row">
            <div className="col centscore">
              <form onSubmit={this.handleSubmit}>
                <label>Enter 1 to 6: </label>
                <input
                  type="text"
                  value={this.state.usernum}
                  onChange={this.handleChange}
                />
              </form>
              <h3>
                User score :{this.state.usertotal}{" "}
                <GetBatter batter={this.state.turn} />
              </h3>
            </div>
            <div className="col centscore">
              <h3>
                Computer score: {this.state.computertotal}{" "}
                <GetBatter batter={Math.abs(this.state.turn - 1)} />{" "}
              </h3>
            </div>
          </div>
        </div>

        {/* winner declare */}
        <h3 className="display-4 d-flex justify-content-center h1color">
          winner is: {this.state.winner}
        </h3>
        {this.state.winner == "user" ? (
          <div className="col imgpad d-flex justify-content-center">
            <Toast>
              <Toast.Body>Winner is {this.state.winner}</Toast.Body>
            </Toast>
          </div>
        ) : (
          <div className="col imgpad d-flex justify-content-center">
            <Toast>
              <Toast.Body></Toast.Body>
            </Toast>
          </div>
        )}
        {/* source: <a href='https://www.freepik.com/vectors/design'>Design vector created by ddraw - www.freepik.com</a> */}
      </div>
    );
  }
}

export default HandCricket;
